import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = { class: "row mleft-04" }
const _hoisted_4 = {
  key: 0,
  class: "mleft-04"
}
const _hoisted_5 = { class: "mleft-auto" }
const _hoisted_6 = { class: "row w-full mtop-04" }
const _hoisted_7 = { class: "bg-blue-04 pad-m rnd-m mtop-20 w-full" }

import { ref, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import editReminderSettings from './editReminderSettings.vue';
import { ApiError, DateFormat } from '@/models/share.model';
import { format } from 'date-fns';
import { AccountingApi, FinancialGroupReminderSettings } from '@/apiGenerate/medserver';
import { toastError } from '@/utils/toast-utils';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useToast } from 'primevue';
import officeapi from "@/api/officeapi"
import loadingSpinner from '@/views/loadingSpinner.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'createReminders',
  props: {
  selectedInvoices: {
    type: Array,
    required: true,
  },
  financialGroup: {
    type: Object,
    required: true,
  }
},
  emits: ['reload'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const accountingApi = new AccountingApi(medServerApiConfig);
const toast = useToast();

const props = __props

const emits = __emit
const dropd = ref();

const reminderDate = ref(new Date());

function updateDate(newDate: Date) {
  reminderDate.value = newDate;
}

const isCreating = ref(false)

async function createReminders() {
  if (isCreating.value) return;
  isCreating.value = true;
  try {
    const invoiceIds = props.selectedInvoices.map(inv => inv.id);
    const reminderDateISO = format(reminderDate.value, DateFormat.ISO_SMALL);
    await officeapi.createInvoiceReminders(invoiceIds, reminderDateISO);
    emits("reload");
  } finally {
    isCreating.value = false;
  }
}

const isLoadingSettings = ref(true);
const reminderSettings = ref<FinancialGroupReminderSettings | null>(null);
async function getReminderSettings() {
  const financialGroupId = props.financialGroup.id;
  if (!financialGroupId) {
    isLoadingSettings.value = false;
    return;
  }
  
  isLoadingSettings.value = true;
  try {
    reminderSettings.value = await accountingApi.getFinancialGroupReminderSettings({financialGroupId: Number(financialGroupId)});
  } catch (e) {
    const error = e as ApiError;
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  } finally {
    isLoadingSettings.value = false;
  }
}

const pendingSettings = ref<FinancialGroupReminderSettings | null>(null);

function handleSettingsChanged(settings: FinancialGroupReminderSettings) {
  pendingSettings.value = settings;
}

async function saveReminderSettings() {
  const financialGroupId = props.financialGroup.id;
  if (!financialGroupId || !pendingSettings.value) return;
  
  try {
    reminderSettings.value = await accountingApi.updateFinancialGroupReminderSettings({
      financialGroupId: Number(financialGroupId),
      financialGroupReminderSettings: pendingSettings.value
    });
    pendingSettings.value = null;
  } catch (e) {
    const error = e as ApiError;
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  }
}

watch(
  () => dropd.value,
  (newValue, oldValue) => {
    if (oldValue === 'EditReminderSettings' && newValue === '') {
      saveReminderSettings();
    }
  }
);

onMounted(() => {
  getReminderSettings();
});

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal row w-maxC gap-20",
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('accounting.invoiceReminder.reminders'),
          styles: "font-l"
        }, null, 8, ["txt"]),
        _createElementVNode("div", _hoisted_3, [
          (isLoadingSettings.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(loadingSpinner, {
                  logo: false,
                  style: 'h-16 w-16'
                })
              ]))
            : (_openBlock(), _createBlock(_component_dropdownBox, {
                key: 1,
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
                openOn: "EditReminderSettings"
              }, {
                dropd: _withCtx(() => [
                  _createVNode(editReminderSettings, {
                    reminderLevel: 1,
                    financialGroup: props.financialGroup,
                    reminderSettings: reminderSettings.value,
                    onSettingsChanged: handleSettingsChanged
                  }, null, 8, ["financialGroup", "reminderSettings"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_es_button_icon, {
                    class: "pad-m",
                    icon: "gear",
                    folder: "menuIcons",
                    styles: "img-grey h-16 w-16"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_button_group, {
            styles: "border-h pad-s",
            class: "psides-06",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (createReminders()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('action.create'),
                styles: `font-mBold ${isCreating.value ? 'main-l' : 'main-h'}`
              }, null, 8, ["txt", "styles"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('accounting.invoice.invoices'),
          styles: "font-mBold main-m"
        }, null, 8, ["txt"]),
        _createVNode(_component_text_item, {
          txt: __props.selectedInvoices.length.toString(),
          styles: "font-mBold main-m",
          class: "mleft-04"
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_esInputDateTime, {
          inline: "",
          dateTimeValue: new Date(),
          dateFormat: _unref(DateFormat).DATEPICKER,
          range: false,
          withTime: false,
          onUpdateDateTime: _cache[2] || (_cache[2] = ($event: any) => (updateDate($event)))
        }, null, 8, ["dateTimeValue", "dateFormat"])
      ])
    ])
  ]))
}
}

})